import { createAsyncThunk } from '@reduxjs/toolkit';

import l10n from '../../shared/strings';
import { buildBulkPublishingScope } from './helpers/buildDraftMediaPayload';

const strings = l10n.ACTIONS_TOOLBAR.PRODUCTS;

const toCount = (value) => {
  if (Array.isArray(value)) return value.length;
  return Number(value) || 0;
};

export const createListingDraftsFromMasters = createAsyncThunk(
  'products/createListingDraftsFromMasters',
  async ({
    masterProductIds,
    masterVariantIds = [],
    salesChannelIds,
    publishingScope,
    replaceExistingDrafts = false,
    selectionProducts = 0,
    selectionVariants = 0,
  }, {
    extra: {
      sdk, Toast, Logger,
    },
  }) => {
    try {
      const { data } = await sdk.products.createListings({
        masterProductIds,
        salesChannelIds,
        publishingScope: buildBulkPublishingScope(publishingScope),
        ...(masterVariantIds.length && { masterVariantIds }),
        ...(replaceExistingDrafts && { replaceExistingDrafts: true }),
      });

      const prepared = toCount(data?.createdListings) + toCount(data?.updatedListings);
      const failed = toCount(data?.failed);
      const skipped = toCount(data?.skipped);
      const total = prepared + failed + skipped;

      if (!prepared && (failed || skipped)) {
        Toast(strings.draftsPreparedNone, { type: 'error', autoClose: false });
        return data;
      }

      if (failed || (total && prepared < total)) {
        Toast(
          `${strings.draftsPreparedSuccess(prepared, total)} ${strings.draftsPreparedPartial(failed || (total - prepared))}`,
          { type: 'warning', autoClose: false },
        );
        return data;
      }

      Toast(
        strings.draftsPreparedForSelection(selectionProducts, selectionVariants)
          || strings.draftsPreparedSuccess(prepared, prepared),
        { type: 'success' },
      );
      return data;
    } catch (error) {
      Toast(strings.draftsPreparedNone, { type: 'error', autoClose: false });
      Logger.error(new Error('Bulk create listing drafts failed'), { error }, [
        'CreateListingDraftsFromMastersFailed',
        { errorMessage: error?.message || 'NoMessage' },
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(createListingDraftsFromMasters.rejected, (state, { error }) => {
    state.error = error?.message || 'Cannot create listing drafts';
  });
};
